var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6V5.25M7.5 9.375V8.625M7.5 12.75V12M3.9 3H14.1C14.9401 3 15.3601 3 15.681 3.16349C15.9632 3.3073 16.1927 3.53677 16.3365 3.81901C16.5 4.13988 16.5 4.55992 16.5 5.4V6.375C15.0503 6.375 13.875 7.55025 13.875 9C13.875 10.4497 15.0503 11.625 16.5 11.625V12.6C16.5 13.4401 16.5 13.8601 16.3365 14.181C16.1927 14.4632 15.9632 14.6927 15.681 14.8365C15.3601 15 14.9401 15 14.1 15H3.9C3.05992 15 2.63988 15 2.31901 14.8365C2.03677 14.6927 1.8073 14.4632 1.66349 14.181C1.5 13.8601 1.5 13.4401 1.5 12.6V11.625C2.94975 11.625 4.125 10.4497 4.125 9C4.125 7.55025 2.94975 6.375 1.5 6.375V5.4C1.5 4.55992 1.5 4.13988 1.66349 3.81901C1.8073 3.53677 2.03677 3.3073 2.31901 3.16349C2.63988 3 3.05992 3 3.9 3Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.4cb786ecc1e75cb791f44a6b2d3fc30d.svg";
export { ForwardRef as ReactComponent };